/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator(), model);
        AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.newInstance(<AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityImpactMetricConfidentialityImpactV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Impact metric(s) confidentiality impact to include
     */
    confidentiality_impact_v31: Array<models.CvssV31ImpactMetrics>;

}
